var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeSpace1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1655,
    height: 50,
    viewBox: "0 0 1655 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1655V50H40L0 0Z",
    fill: "#0132B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSpace1);
export default __webpack_public_path__ + "static/media/shape_space_1.4e29ec4b35c80060ab4ce65c201d5a10.svg";
export { ForwardRef as ReactComponent };